import styled from "styled-components";
import { Link } from "gatsby";
import arrowSvg from "@assets/images/icons/arrow_down.svg";

export const Container = styled.div`
  padding: 24px 40px;
  background-color: #141301;
  opacity: 0.9;
  position: fixed;
  height: 100%;
  max-height: calc(100vh - 90px);
  width: 100%;
  top: 90px;
  z-index: 99999;
  box-sizing: border-box;
  overflow-y: auto;

  @media (max-width: 600px) {
    top: 87px;
    opacity: 1;
    padding: 24px;
    max-height: calc(100vh - 87px);
  }

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #141301;
  }
  &::-webkit-scrollbar-thumb {
    background: #2a2904;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #3a3906;
  }
`;

export const MenuItems = styled.div`
  width: 50%;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ active }) => (active ? "unset" : "solid 1px #BABABA")};
  padding: 13px 0;

  div {
    transform: ${({ active }) => active && "rotate(180deg)"};
  }
`;

export const ArrowIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: #fff6ed;
  -webkit-mask: url(${arrowSvg}) no-repeat center;
  mask: url(${arrowSvg}) no-repeat center;
  mask-size: contain;
  -webkit-mask-size: contain;
  transition: transform 0.3s ease;
`;

export const ItemWrapper = styled.div`
  max-height: ${({ active }) => (active ? "1000px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
`;

export const DirectLink = styled(Link)`
  color: #fff6ed;
  font-size: 36px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.205px;
  text-transform: uppercase;
  text-decoration: none;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 29px;
    line-height: 26px;
    letter-spacing: 0.164px;
  }
`;

export const ExternalLink = styled.a`
  color: #fff6ed;
  font-size: 36px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.205px;
  text-transform: uppercase;
  text-decoration: none;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 29px;
    line-height: 26px;
    letter-spacing: 0.164px;
  }
`;
